// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_ua-0";
export var checkoutRateBadgeLink = "_ua-1";